import React, {Fragment} from "react";
import {connect} from "react-redux";
import {translate} from '@elements/translations';
import {useConfirmModal} from "../../shared/components/ConfirmModal";
import {formatDate} from "../../shared/utils";
import {reactOffer} from "../actions/actions";
import Loading from "../../shared/components/Loading";

const TableRowItem = ({item, declineReasons, onReact}) => {

    const handleReaction = (type, note, reason) => {
        if (!item.disabled) {
            onReact(item, type, note || '', reason);
        }
    }

    const {open: openAccept, confirmModal: confirmModalAccept} = useConfirmModal((value) => {handleReaction('accept', value)}, {
        title: translate('offer.accept-modal.title'),
        confirmStyle: 'success',
        message: translate('offer.accept-modal.message'),
        confirmText: translate('offer.accept-modal.confirm'),
        confirmIcon: ''
    });

    const {open: openDecline, confirmModal: confirmModalDecline} = useConfirmModal((value, reason) => {handleReaction('decline', value, reason)}, {
        title: translate('offer.decline-modal.title'),
        confirmStyle: 'danger',
        message: translate('offer.decline-modal.message'),
        confirmText: translate('offer.decline-modal.confirm'),
        confirmIcon: '',
        hasInput: true,
        inputLabel: translate('offer.decline-modal.input-label'),
        reasons: {
            label: translate('offer.decline-modal.reasons'),
            options: declineReasons
        }
    });

    const {open: openChange, confirmModal: confirmModalChange} = useConfirmModal((value) => {handleReaction('change', value)}, {
        title: translate('offer.change-modal.title'),
        confirmStyle: 'primary',
        message: translate('offer.change-modal.message'),
        confirmText: translate('offer.change-modal.confirm'),
        confirmIcon: '',
        hasInput: true,
        inputLabel: translate('offer.change-modal.input-label')
    });

    const actionButtons = (
        <>
            <button type="button"
                    className={`btn ${item.disabled ? 'btn-dark is-disabled' : 'btn-primary'} btn-sm`}
                    disabled={item.disabled}
                    onClick={() => openAccept()}
            >{translate('offers.accept')}</button>

            <button type="button"
                    className={`btn ${item.disabled ? 'btn-dark is-disabled' : 'btn-primary'} btn-sm`}
                    disabled={item.disabled}
                    onClick={() => openDecline()}
            >{translate('offers.decline')}</button>

            <button type="button"
                    className={`btn ${item.disabled ? 'btn-dark is-disabled' : 'btn-primary'} btn-sm`}
                    disabled={item.disabled}
                    onClick={() => openChange()}
            >{translate('offers.change')}</button>
        </>
    );

    return (
        <Fragment>
            <tr>
                <td>{formatDate(item.date, _config.lang)}</td>
                <td>{item.number}</td>
                <td>{item.reference}</td>
                <td className="text-end">{item.total}</td>
                <td>{formatDate(item.validThrough, _config.lang)}</td>
                <td className={'text-end table__body-actions position-relative'}>
                    <div className="d-flex flex-column gap-2 align-items-center">

                        <div className="d-flex gap-2 justify-content-end align-items-center">
                            {item.loading && (
                                <Loading className="loading-overlay--centered"/>
                            )}
                            {item.pdfLink ? (
                                <a href={item.pdfLink} target="_blank"
                                   className="btn btn-sm btn-link p-0 text-end text-nowrap">{translate('offers.show-pdf')}</a>
                            ) : null}
                            {item.action ? (
                              <div className="d-flex flex-column">
                                    <div className="d-flex gap-2">
                                        {actionButtons}
                                    </div>
                                  <div className="text-start small mt-1">{`${translate(`offers.reaction.${item.action}`)} ${formatDate(item.lastActionDate, _config.lang)}`}</div>
                              </div>

                            ) : (
                                <div className="d-flex gap-2">
                                    {actionButtons}
                                </div>
                            )
                            }
                        </div>
                    </div>
                </td>
            </tr>
            {confirmModalAccept}
            {confirmModalDecline}
            {confirmModalChange}
        </Fragment>
    );
};


const mapStateToProps = (state, props) => {
    return {
        item: props.item
    }
};

export const mapDispatchToProps = (dispatch) => {
    return {
        onReact: (item, type, note, reason) => dispatch(reactOffer(item, type, note, reason)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TableRowItem)
